import { render, staticRenderFns } from "./CustomForm.vue?vue&type=template&id=50d78398&scoped=true"
import script from "./CustomForm.vue?vue&type=script&lang=js"
export * from "./CustomForm.vue?vue&type=script&lang=js"
import style0 from "./CustomForm.vue?vue&type=style&index=0&id=50d78398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d78398",
  null
  
)

export default component.exports